//百果园
import Overview from './overview.vue';
import MobFull from '@rebuild/materials/shared/analyst/MobFull.vue';

export const componentMap = {
	overview: Overview,
	'mob-full': MobFull
}; 